import Select from 'react-select';

const PropertySelect = ({ property, properties, onChange }) => {
  return (
    <Select
      value={property ? { value: property.id, label: property.name } : null}
      onChange={onChange}
      options={properties.map((p) => {
        return {
          value: p.id,
          label: p.name
        };
      })}
    />
  );
};

export default PropertySelect;

